import { User } from './user.model';

export class ReportListModel {
  id: string;
  name: string;
  description: string;
  supportedOutputs: string[];
  time: number;
  usedTimes: number;
  tags: {
    color: string,
    name: string;
  }[];

  constructor(input: any = {}) {
    this.id = input.id;
    this.name = input.name;
    this.description = input.description;
    this.supportedOutputs = input.supportedOutputs;
    this.tags = input.tags?.map((tag: string) => {
      return { name: '#' + tag.split(',')[0], color: tag.split(',')[1] };
    }) ?? [];
    this.time = input.time;
    this.usedTimes = input.usedTimes;

  }
}

export class ReportInputModel {
  id: string;
  type: string;
  label: string;
  value: string;
  required: boolean;
  extraParams: { id: string, label: string }[];

  constructor(input: any = {}) {
    this.id = input.id;
    this.type = input.type;
    this.label = input.label;
    this.required = input.required;
    this.extraParams = input.extraParams;
    this.value = input.value;
  }
}

export interface ReportResult {
  [key: string]: unknown;
}

export interface ReportOutputModel {
  id: string;
  type: string;
  label: string;
  value: string;
  required: boolean;
  extraParams: { [key: string]: string };

}

export interface ReportApiType {
  method: string;
  url: string;
  fields: ReportInputModel[];
  label: string;
}

export interface ReportDecimalType {
  suffix: string;
  prefix: string;
  value: string;
}

export class ReportAccessList {
  id: string;
  name: string;
  description: string;
  supportedOutputs: string[];
  tags: {
    color: string,
    name: string;
  }[];
  scopePermissions: {
    id: number,
    name: string;
  }[];
  userPermissions: User[];

  constructor(input: any = {}) {
    this.id = input.id;
    this.name = input.name;
    this.description = input.description;
    this.supportedOutputs = input.supportedOutputs;
    this.tags = input.tags?.map((tag: string) => {
      return { name: '#' + tag.split(',')[0], color: tag.split(',')[1] };
    }) ?? [];
    this.scopePermissions = input.permissions.filter((each: any) => each.type == 'scope').map((each: any) => each.scope);
    this.userPermissions = input.permissions.filter((each: any) => each.type == 'user').map((each: any) => new User(each.user));
  }
}


export class ReportQueueList {
  id: number;
  name: string;
  filter: unknown[];
  status: string;
  link: string;
  createdAt: string;
  startedAt: string;
  finishedAt: string;

  constructor(input: any = {}) {
    this.id = input.id;
    this.name = input.reportName;
    this.link = input.filePath;
    this.status = input.status;
    delete input.reportPayload['__type'];
    this.filter = input.reportPayload;
    this.createdAt = input.createdAt;
    this.finishedAt = input.finishedAt;
    this.startedAt = input.startedAt;
  }
}
